export default "__VITE_ASSET__DkbI6M2p__"